require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/fn/array/includes.js
// module id = 1013
// module chunks = 0